import React from "react"

const AdobeContext = React.createContext({
  analytics: {},
  setAnalytics: () => {}
});

export default AdobeContext